import { Close } from "@mui/icons-material";
import { AlertProps, IconButton, Snackbar } from "@mui/material";
import React from "react";

import { useNotification } from "../../hooks/useNotification";
import { useAppSelector } from "../../store";
import { StyledMuiAlert } from "./Notification.styled";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props: any, ref: any) => (
  <StyledMuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
Alert.displayName = 'Alert';

export const Notification = () => {
  const notification = useAppSelector(state => state.store.notification);
  const { notify } = useNotification();

  if(!notification) {
    return null;
  }

  const handleClose = (_: any, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    notify(null);
  };

  const { message, hideDuration, type } = notification;

  const ActionWrapper = (
    <>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <Close fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      open={!!notification}
      autoHideDuration={hideDuration || 6000}
      onClose={handleClose}
      message={message}
      action={ActionWrapper}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={type ?? 'success'} action={ActionWrapper}>
        {message}
      </Alert>
    </Snackbar>
  )
}
